<template>
  <div></div>
</template>
<script>
export default {
  name: 'CommonFunction',
  data () {
    return {}
  },
  methods: {
    base64Encode (...parts) {
      return new Promise(resolve => {
        const reader = new FileReader()
        reader.onload = () => {
          const offset = reader.result.indexOf(',') + 1
          resolve(reader.result.slice(offset))
        }
        reader.readAsDataURL(new Blob(parts))
      })
    },
    validateFileSize (file) {
      if (file.size >= this.consts.maxUploadFileSize) {
        return false
      }
      return true
    }
  }
}
</script>
